import React, { Children, memo } from 'react'
import styled, { css } from 'styled-components/macro'
import range from 'lodash/range'
import uniqueId from 'lodash/uniqueId'
import media from 'styles/mixins/media'

const Filler = styled.div``

const RowContainer = styled.div`
  display: flex;

  ${props => props.align === 'center' ? css`
    align-items: center;
  ` : props.align === 'bottom' ? css`
    align-items: flex-end;
  ` : props.align === 'top' && css`
    align-items: flex-start;
  ` }

  ${props => props.justify === 'center' ? css`
    justify-content: center;
  ` : props.justify === 'bottom' ? css`
    justify-content: flex-end;
  ` : props.justify === 'top' && css`
    justify-content: flex-start;
  ` }

  & > * {
    flex: 1 1 100%;
  }

  ${props => props.mobiletoo ? css`
    & > :not(:first-child) {
      margin-left: ${props => props.margin || '2.4rem'};
    }
  ` : css`
    ${media('tablet', 'desktop')`
      & > :not(:first-child) {
        margin-left: ${props => props.margin || '2.4rem'};
      }
    `}

    ${media.mobile`
      flex-wrap: ${props => props.wrapIfMobile ? 'wrap' : 'nowrap'};
      
      ${props => props.wrapIfMobile ? css`
        & > :not(:first-child):not(${Filler}) {
          margin-top: ${props => props.margin || '2.4rem'};
        }
      ` : css`
        & > :not(:first-child):not(${Filler}) {
          margin-left: ${props => props.margin};
        }
      `}
    `}
  `}
`

export const Row = memo(props => {
  const id = `Row-${uniqueId()}`
  const items = []
  Children.forEach(props.children, child => child && items.push(child))
  const fillers = range(Math.max(0, (props.columns || 0) - items.length)).map(i => <Filler key={`${id}-filler-${i}`} />)
  const { wrapIfMobile = true } = props
  return <RowContainer className={props.className} mobiletoo={props.mobiletoo} align={props.align} margin={props.margin} wrapIfMobile={wrapIfMobile}>{[...items, ...fillers]}</RowContainer>
})

